export enum VtaasRole {
  ADMIN = 'admin',
  SAMSONVT = 'samsonvt',
  DEMO = 'demo',
  READONLY = 'readonly',
  NOACCESS = 'noaccess',
  VIEWER = 'viewer',
}
